// eslint-disable-next-line import/prefer-default-export
export const SCROLL_WIDTH_OFFSET = 5;
export const SCROLL_BAR_LINE_ID = 'scrollbar-line';
export const SCROLL_BAR_CONTAINER_ID = 'scrollbar-container';
